import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Upload, EAA_ErrorText } from '~/components/EditAndAddItem';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import * as getTime from '~/skills/getTime';

import Sub3 from './Sub3';

const ConsultMeet = props => {
  const { titleWidth, disabled, checkChange, data, changeData, errorAry, errorLeft } = props;
  const ary = Sub3(props);
  const endAry = [
    <EAA_Row key='Page_ForeignBoat_ConsultMeet_end_1'>
      <EAA_Item>
        <EAA_ItemContainer>
          <EAA_TitleText width={titleWidth} text='' />
          <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>通過與否</div>
          <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>上傳會議紀要函文</div>
          <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 150 }} />
        </EAA_ItemContainer>
      </EAA_Item>
    </EAA_Row>,
    <EAA_Row style={{ marginTop: 0 }} key='Page_ForeignBoat_ConsultMeet_end_2'>
      <EAA_Item>
        <EAA_ItemContainer>
          <EAA_TitleText width={titleWidth} />
          <div style={{ flex: 1, marginRight: 8, display: 'flex' }}>
            <CircleCheckBox disabled={disabled} value={data.is_pass === '1'} onClick={() => changeData({ label: 'is_pass', data: '1' })} />
            <div style={{ marginRight: 8 }}>不通過</div>
            <CircleCheckBox disabled={disabled} value={data.is_pass === '2'} onClick={() => changeData({ label: 'is_pass', data: '2' })} />
            <div>通過</div>
          </div>
          <EAA_Upload displayBorder disabled={disabled} marginRight={8} value={data.meet_upload_files || []} onChange={data => changeData({ label: 'meet_upload_files', data })} />
          <div style={{ flex: 1, marginRight: 8 }} />
          <div style={{ width: 150 }} />
        </EAA_ItemContainer>
        {errorAry[11] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選『通過與否』' />}
        {errorAry[12] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳『會議紀要函文』' />}
      </EAA_Item>
    </EAA_Row>,
  ];
  return [...ary, ...endAry];
};
export default ConsultMeet;
